"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var material_1 = require("@mui/material");
var react_1 = require("react");
var CustomTableRow_1 = __importDefault(require("./CustomTableRow"));
var TableLoading_1 = __importDefault(require("./TableLoading"));
function TableComponent(_a) {
    var rows = _a.rows, columns = _a.columns, _b = _a.size, size = _b === void 0 ? 'medium' : _b, _c = _a.stickyHeader, stickyHeader = _c === void 0 ? false : _c, _d = _a.isLoading, isLoading = _d === void 0 ? false : _d, keyExtractor = _a.keyExtractor, _e = _a.maxHeight, maxHeight = _e === void 0 ? 'calc(100vh - 400px)' : _e;
    return ((0, jsx_runtime_1.jsx)(material_1.TableContainer, __assign({ style: {
            overflowY: 'initial',
            maxHeight: maxHeight,
        } }, { children: (0, jsx_runtime_1.jsxs)(material_1.Table, __assign({ stickyHeader: stickyHeader, size: size }, { children: [(0, jsx_runtime_1.jsx)(material_1.TableHead, { children: (0, jsx_runtime_1.jsx)(material_1.TableRow, { children: columns === null || columns === void 0 ? void 0 : columns.filter(function (c) { return Boolean(c); }).map(function (column, i) {
                            var _a;
                            return ((0, jsx_runtime_1.jsx)(material_1.TableCell, __assign({ sx: {
                                    textTransform: 'uppercase',
                                    fontWeight: 'bold',
                                    color: 'grayText',
                                    width: column.width,
                                }, align: (_a = column.align) !== null && _a !== void 0 ? _a : 'inherit' }, { children: column.label }), column.label));
                        }) }) }), (0, jsx_runtime_1.jsxs)(material_1.TableBody, { children: [isLoading && (0, jsx_runtime_1.jsx)(TableLoading_1.default, { colsCount: columns.length }), !isLoading && rows.length === 0 && ((0, jsx_runtime_1.jsx)(material_1.TableRow, { children: (0, jsx_runtime_1.jsx)(material_1.TableCell, __assign({ colSpan: columns.length, align: "center" }, { children: "No hay datos registrados." })) })), rows.length > 0 &&
                            (rows === null || rows === void 0 ? void 0 : rows.map(function (item, i) { return ((0, jsx_runtime_1.jsx)(CustomTableRow_1.default, { item: item, columns: columns }, keyExtractor(item))); }))] })] })) })));
}
exports.default = (0, react_1.memo)(TableComponent);
